import React from 'react';
import * as THREE from 'three';

interface CargoBoxProps {
    dimensions: {
        width: number;
        height: number;
        depth: number;
    };
    theme?: 'light' | 'dark';
    opacity?: number;
}

function CargoBox({ dimensions, theme = 'dark', opacity = 1 }: CargoBoxProps) {
    const { width, height, depth } = dimensions;
    const isDark = theme === 'dark';

    // Maximum Brightness Technical Palette
    const boxColor = isDark ? '#F3F4F6' : '#FFFFFF'; // Pure White / Lightest Gray
    const edgeColor = isDark ? '#94A3B8' : '#E2E8F0'; // Very soft edges
    const edgeOpacity = isDark ? 0.8 : 0.9;

    return (
        <group>
            {/* The Prism Box */}
            <mesh castShadow receiveShadow>
                <boxGeometry args={[width, height, depth]} />
                <meshStandardMaterial
                    color={boxColor}
                    transparent={opacity < 1}
                    opacity={opacity}
                    roughness={0.9}
                    metalness={0.1}
                    side={THREE.DoubleSide}
                    depthWrite={opacity >= 1}
                />
            </mesh>

            {/* Edges */}
            <lineSegments>
                <edgesGeometry args={[new THREE.BoxGeometry(width, height, depth)]} />
                <lineBasicMaterial color={edgeColor} opacity={edgeOpacity * opacity} transparent={opacity < 1} />
            </lineSegments>
        </group>
    );
}

export default CargoBox;
